export interface FilterConfig {
  sport?: string | null;
  level?: string | null;
  season?: number | null;
}

export interface ApiQueryParams {
  [key: string]: string | number | boolean | undefined;
}

export const buildQueryParams = (filters: FilterConfig): ApiQueryParams => {
  const params: ApiQueryParams = {};

  if (filters.sport) {
    params.sport__slug = filters.sport;
  }

  if (filters.level) {
    const levelMap: Record<string, string> = {
      'professional': 'professional',
      'college': 'ncaa-division-i',
      'ncaa-division-i': 'ncaa-division-i',
      'ncaa-division-ii': 'ncaa-division-ii',
      'ncaa-division-iii': 'ncaa-division-iii',
    };
    params.level__slug = levelMap[filters.level] || filters.level;
  }

  if (filters.season) {
    params.season = filters.season;
  }

  return params;
};

export const buildQueryString = (params: ApiQueryParams): string => {
  const searchParams = new URLSearchParams();
  
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      searchParams.append(key, String(value));
    }
  });
  
  const queryString = searchParams.toString();
  return queryString ? `?${queryString}` : '';
};

export const appendFiltersToUrl = (baseUrl: string, filters: FilterConfig): string => {
  const params = buildQueryParams(filters);
  const queryString = buildQueryString(params);
  return `${baseUrl}${queryString}`;
};